import { useEffect } from 'react';
import type { ReactElement } from 'react';

import { AppBackground } from '@/presentation/widgets/AppBackground';
import { installScreenMetrics } from '@/utils/screenUtil';

import styles from './AppLoading.module.css';

/**
 * Перенос экрана «до инициализации» из `lib/main.dart`:
 * `AppBuilder.builder` рисовал его, пока `preInitialize` не вернул
 * `AppInitialState`.
 *
 *     Scaffold(
 *       backgroundColor: Colors.transparent,
 *       body: Stack(fit: expand, children: [
 *         AppBackground(),
 *         Center(child: CircularProgressIndicator(color: Colors.white)),
 *       ]),
 *     )
 *
 * Хосты тостов и слоя загрузки здесь не монтируются: показывать во время
 * старта нечего, а `bootstrapApp` ловит любой сбой сам и повторяет попытку.
 * Метрики экрана, наоборот, нужны — по `data-orientation` фон выбирает
 * книжную или альбомную картинку (в Dart их ставил `ScreenUtilInit`
 * из `AppSettingsWrapper`, которым была обёрнута и эта заставка).
 */

/** CircularProgressIndicator: размер 36 и толщина дуги 4 — как во Flutter. */
const SPINNER_VIEW_BOX = '0 0 36 36';
const SPINNER_CENTER = 18;
const SPINNER_RADIUS = 16;

export function AppLoading(): ReactElement {
  useEffect(() => installScreenMetrics(), []);

  return (
    <div className={styles.root}>
      <AppBackground />
      <div className={styles.center}>
        <svg className={styles.spinner} viewBox={SPINNER_VIEW_BOX} role="presentation">
          <circle
            className={styles.arc}
            cx={SPINNER_CENTER}
            cy={SPINNER_CENTER}
            r={SPINNER_RADIUS}
          />
        </svg>
      </div>
    </div>
  );
}
